/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React Base Styles
import colors from '../../colors';
import typography from '../../typography';
import boxShadows from '../../boxShadows';

// Soft UI Dashboard PRO React Helper Functions
import pxToRem from '../../../functions/pxToRem';

const { transparent, light, info, secondary } = colors;
const { size } = typography;
const { buttonBoxShadow } = boxShadows;

export default {
    base: {
        minHeight: pxToRem(42),
        color: light.main,
        borderColor: light.main,
        padding: `${pxToRem(12)} ${pxToRem(24)}`,

        '&:hover': {
            opacity: 0.75,
            backgroundColor: transparent.main,
        },

        '&:focus:not(:hover)': {
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },

        '& .material-icon, .material-icons-round, svg:not(.custom-size)': {
            fontSize: `${pxToRem(20)} !important`,
        },
    },

    small: {
        minHeight: pxToRem(34),
        padding: `${pxToRem(8)} ${pxToRem(16)}`,
        fontSize: size.xs,
        lineHeight: pxToRem(16),

        '& .material-icon, .material-icons-round, svg:not(.custom-size)': {
            fontSize: `${pxToRem(16)} !important`,
        },
    },

    large: {
        minHeight: pxToRem(49),
        padding: `${pxToRem(14)} ${pxToRem(40)}`,
        fontSize: size.xl,

        '& .material-icon, .material-icons-round, svg:not(.custom-size)': {
            fontSize: `${pxToRem(24)} !important`,
        },
    },

    primary: {
        backgroundColor: transparent.main,
        borderColor: info.main,

        '&:hover': {
            backgroundColor: transparent.main,
        },

        '&:focus:not(:hover)': {
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },

    secondary: {
        backgroundColor: transparent.main,
        borderColor: secondary.main,

        '&:hover': {
            backgroundColor: transparent.main,
        },

        '&:focus:not(:hover)': {
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },
};
